import type {
  AgentResponse,
  CreateAgentRequest,
  TransformedCreateAgentBody,
  TransformedUpdateAgentBody,
  UpdateAgentRequest,
} from '../api-types/agent';
import type { Agent } from '../types/agent';

export const transformCreateAgentRequest = (request: CreateAgentRequest): TransformedCreateAgentBody => ({
  name: request.name,
  description: request.description,
  system_prompt: request.systemPrompt,
  dbid: request.dbId,
  project_id: request.projectId,
  organization_id: request.organizationId,
  is_private: request.isPrivate,
});

export const transformUpdateAgentRequest = (request: UpdateAgentRequest): TransformedUpdateAgentBody => ({
  name: request.name,
  description: request.description,
  system_prompt: request.systemPrompt,
  dbid: request.dbId,
  is_private: request.isPrivate,
});

export const transformCreateAgentResponse = (response: AgentResponse): Agent => ({
  id: response.id,
  name: response.name,
  description: response.description,
  systemPrompt: response.system_prompt,
  dbId: response.dbid,
  projectId: response.project_id,
  organizationId: response.organization_id,
  createdBy: response.created_by,
  isPrivate: response.is_private,
  endpointLink: response.endpoint_link,
});

export const transformListAgentsResponse = (response: AgentResponse[]): Agent[] => {
  return response.map((agent) => ({
    id: agent.id,
    name: agent.name,
    description: agent.description,
    systemPrompt: agent.system_prompt,
    dbId: agent.dbid,
    projectId: agent.project_id,
    organizationId: agent.organization_id,
    createdBy: agent.created_by,
    isPrivate: agent.is_private,
    endpointLink: agent.endpoint_link,
  }));
};
